import { render, staticRenderFns } from "./pointDeVente.vue?vue&type=template&id=1ea8cb2c"
import script from "./pointDeVente.vue?vue&type=script&lang=js"
export * from "./pointDeVente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports